module.exports = __webpack_public_path__ + "499e56ce27a3076f6783444b25106c69.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/phyto/clear-cream.jpg
 ** module id = 480
 ** module chunks = 0
 **/